import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const relativeList = createAsyncThunk(
  'tools/relative-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}tools/relative-list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const relativeStore = createAsyncThunk(
  'tools/relative-store',
  async (subjectData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}tools/relative-store`, subjectData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const relativeEdit = createAsyncThunk('tools/relative-edit', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}tools/relative-edit/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const cardDesignList = createAsyncThunk(
  'tools/card-design-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}tools/card-design-list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const cardDesignStore = createAsyncThunk(
  'tools/card-design-store',
  async (subjectData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}tools/card-design-store`, subjectData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const cardDesignEdit = createAsyncThunk('tools/card-design-edit', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}tools/card-design-edit/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const toggleCardDesign = createAsyncThunk('card-design-toggle', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}tools/toggle/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type ToolsState = {
  errors: any
}

const initialState: ToolsState = {
  errors: '',
}

export const toolsSlice = createSlice({
  name: 'tools',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(relativeStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = toolsSlice.actions
export default toolsSlice.reducer
